// ABOUTME: Route for /library/$documentId/images.
// ABOUTME: Renders the DocumentImages component showing all images from a document.

import DocumentImages from "@/components/DocumentImages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/library/$documentId/images",
)({
  component: DocumentImages,
});
